import {setStoreTheme} from "stores/theme"
import {ThemeTypeEnum} from "./data"

/**
 * Applies the specified theme by updating the root HTML element's class list
 * and syncing the theme value to the application store.
 *
 * The function ensures that the theme class on the root `<html>` element matches the specified theme.
 * It also updates the application store with the selected theme.
 *
 * @param {import("./data").ThemeType} theme The theme to apply.
 *
 * @example
 * applyTheme("dark"); // Updates the root element class and application store with "dark".
 */
export const applyTheme = theme => {
  // Update root HTML element's class list
  const root = window.document.documentElement
  const isDark = theme === ThemeTypeEnum.enum.dark
  root.classList.remove(
    isDark ? ThemeTypeEnum.enum.light : ThemeTypeEnum.enum.dark,
  )
  root.classList.add(theme)

  // Update application store
  setStoreTheme(theme)
}
